






























































































import Vue from "vue";

// Vuex
import { mapState } from "vuex";
import { RootState } from "@/store";

// Model
import { VersionObfuscator } from "@/model/data/updates/VersionObfuscator";
import { UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { SoftwareFilter } from "@/model/data/updates/SoftwareFilter";
import { NamedSoftwareVersion } from "@/model/data/updates/NamedSoftwareVersion";
import { SoftwareVersionsSubset } from "@/model/data/updates/SoftwareVersionsSubset";
import { ComparisonOperatorEnum, comparisonOperatorEnumLabel } from "@/model/data/enums/ComparisonOperatorEnum";

class ObfuscatedVersion {
    obfuscatedVersion: string;
    versions: string[] = [];

    constructor(obfuscatedVersion: string, singleVersion: string) {
        this.obfuscatedVersion = obfuscatedVersion;
        this.versions.push(singleVersion);
    }
}

export default Vue.extend({
    data() {
        return {
            isMenuOpen: false,
            obfuscatedAvailableItems: new Array<ObfuscatedVersion>(),
            radioGroup: 2,
            selectedSign: null,
            selectedVersion: null,
            selectedObfuscatedVersions: [],
        };
    },
    props: {
        value: Object as () => SoftwareVersionsSubset,
        showOnlyMultipleSelection: Boolean,
    },
    computed: {
        ...mapState({
            availableSoftwares: (state: RootState): SoftwareFilter[] => state.application.availableSoftwareVersions,
        }),

        swUpdateType() {
            return (this.value as SoftwareVersionsSubset).updateType;
        },

        swName() {
            return (this.value as SoftwareVersionsSubset).name;
        },

        availableSing() {
            let items = [];
            items.push({ value: ComparisonOperatorEnum.LessThanOrEqualTo, text: this.$t(comparisonOperatorEnumLabel(ComparisonOperatorEnum.LessThanOrEqualTo)) });
            items.push({ value: ComparisonOperatorEnum.GreaterThanOrEqualTo, text: this.$t(comparisonOperatorEnumLabel(ComparisonOperatorEnum.GreaterThanOrEqualTo)) });
            return items;
        },

        availableSwsFilterByTypeAndName() {
            let res = [];
            if (Array.isArray(this.availableSoftwares) && this.availableSoftwares.length)
                if (this.availableSoftwares.some((sw: SoftwareFilter) => sw.updateType == this.swUpdateType)) {
                    // se sono un sw di terze parti ed ho specificato il nome del sw filtro versionList
                    if (this.swUpdateType == UpdateTypeEnum.ThirdPartySoftware && this.swName)
                        res = this.availableSoftwares.find((sw) => sw.updateType == this.swUpdateType).versionsList.filter((v: NamedSoftwareVersion) => v.name == this.swName);
                    // altrimenti non filtro versionList
                    else res = this.availableSoftwares.find((sw: SoftwareFilter) => sw.updateType == this.swUpdateType).versionsList;
                }
            return res;
        },
    },
    watch: {
        availableSwsFilterByTypeAndName() {
            this.setObfuscatedAvailableItems();
        },

        obfuscatedAvailableItems(newObfuscatedAvailableItems) {
            // ogni volta che cambiano le versioni nelle combobox, imposto la prima versione nel radiogroup 0
            if (Array.isArray(newObfuscatedAvailableItems) && newObfuscatedAvailableItems.length) this.selectedVersion = newObfuscatedAvailableItems[0].obfuscatedVersion;
        },

        value() {
            this.setToValue();
        },
    },
    methods: {
        setToDefault() {
            this.obfuscatedAvailableItems = [];
            this.radioGroup = 2;
            this.setRadioGroup0SectionToDefault(); // impostazioni di default per il radioGroup 0
            this.setRadioGroup1SectionToDefault(); // impostazioni di default per il radiogroup 1
            this.setObfuscatedAvailableItems();
        },

        setRadioGroup1SectionToDefault() {
            this.selectedObfuscatedVersions = [];
        },

        setRadioGroup0SectionToDefault() {
            this.selectedSign = this.availableSing[0];
            if (Array.isArray(this.obfuscatedAvailableItems) && this.obfuscatedAvailableItems.length) this.selectedVersion = this.obfuscatedAvailableItems[0].obfuscatedVersion;
            else this.selectedVersion = null;
        },

        setToValue() {
            if (this.value.versions.length) {
                switch (this.value.comparisonOperator as ComparisonOperatorEnum) {
                    case ComparisonOperatorEnum.GreaterThanOrEqualTo:
                        this.radioGroup = 0;
                        this.selectedSign = this.availableSing.find((c) => c.value == ComparisonOperatorEnum.GreaterThanOrEqualTo);
                        this.selectedVersion = this.value.versions[0];
                        this.setRadioGroup1SectionToDefault(); // impostazioni di default per il radiogroup 1
                        break;
                    case ComparisonOperatorEnum.LessThanOrEqualTo:
                        this.radioGroup = 0;
                        this.selectedSign = this.availableSing.find((c) => c.value == ComparisonOperatorEnum.LessThanOrEqualTo);
                        this.selectedVersion = this.value.versions[0];
                        this.setRadioGroup1SectionToDefault(); // impostazioni di default per il radiogroup 1
                        break;
                    case ComparisonOperatorEnum.EqualTo:
                        this.radioGroup = 1;
                        // da una lista di versioni non offuscate devo ricavare quelle offuscate
                        this.selectedObfuscatedVersions = [];
                        if (Array.isArray(this.obfuscatedAvailableItems) && this.obfuscatedAvailableItems.length) {
                            this.value.versions.forEach((v) => {
                                let ovTemp: ObfuscatedVersion = this.obfuscatedAvailableItems.find((ov: ObfuscatedVersion) => ov.versions.indexOf(v) >= 0);
                                if (ovTemp && this.selectedObfuscatedVersions.indexOf(ovTemp.obfuscatedVersion) < 0) this.selectedObfuscatedVersions.push(ovTemp.obfuscatedVersion);
                            });
                        }
                        this.setRadioGroup0SectionToDefault(); // impostazioni di default per il radioGroup 0
                        break;
                    default:
                        break;
                }
            } else {
                this.radioGroup = 2;
                this.setRadioGroup0SectionToDefault(); // impostazioni di default per il radioGroup 0
                this.setRadioGroup1SectionToDefault(); // impostazioni di default per il radiogroup 1
            }
        },

        setObfuscatedAvailableItems() {
            this.obfuscatedAvailableItems = [];
            if (this.availableSwsFilterByTypeAndName.length > 0) {
                // calcolo le versioni (offuscate) da visualizzare nelle combobox
                this.availableSwsFilterByTypeAndName.forEach((item: NamedSoftwareVersion) => {
                    let key = VersionObfuscator.obfuscate(item.version.trim());

                    let find = this.obfuscatedAvailableItems.find((v: ObfuscatedVersion) => v.obfuscatedVersion === key);
                    if (find) find.versions.push(item.version.trim());
                    else this.obfuscatedAvailableItems.push(new ObfuscatedVersion(key, item.version.trim()));
                });
            }
        },

        onApply() {
            let softwareVersionsSubsetObjectToEmit: SoftwareVersionsSubset = new SoftwareVersionsSubset();
            softwareVersionsSubsetObjectToEmit.updateType = this.swUpdateType;
            softwareVersionsSubsetObjectToEmit.name = this.swName;

            switch (this.radioGroup) {
                // <= or >= than
                case 0:
                    this.setRadioGroup1SectionToDefault(); // impostazioni di default per il radiogroup 1
                    softwareVersionsSubsetObjectToEmit.comparisonOperator = this.selectedSign.value as ComparisonOperatorEnum;
                    // dal momento che questa opzione del radioGroup c'è solo per tipi di sw per i quali non viene fatto offuscamento
                    softwareVersionsSubsetObjectToEmit.versions.push(this.selectedVersion);
                    break;
                // custom selection
                case 1:
                    this.setRadioGroup0SectionToDefault(); // impostazioni di default per il radioGroup 0
                    softwareVersionsSubsetObjectToEmit.comparisonOperator = ComparisonOperatorEnum.EqualTo;
                    // calcolo le versioni da mandare
                    this.selectedObfuscatedVersions.forEach((version: string) => {
                        this.obfuscatedAvailableItems
                            .find((ov: ObfuscatedVersion) => ov.obfuscatedVersion == version)
                            .versions.forEach((v: string) => {
                                softwareVersionsSubsetObjectToEmit.versions.push(v);
                            });
                    });
                    break;
                default:
                    // impostazioni di default per il radioGroup 0
                    this.setRadioGroup0SectionToDefault();
                    // impostazioni di default per il radiogroup 1
                    this.setRadioGroup1SectionToDefault();
                    break;
            }

            this.$emit("input", softwareVersionsSubsetObjectToEmit);

            this.isMenuOpen = false;
        },

        closeMenu() {
            this.isMenuOpen = false;
            this.setToValue();
        },
    },
    mounted() {
        this.setToDefault();
        this.setToValue();
    },
});
